import { Grid } from '@mui/material';
import styled from '@emotion/styled';

import { BREAKPOINTS, COLORS, FONT_WEIGHT, SPACE } from '../../constants';
import StarRating from '../star-rating';
import { shouldForwardProp } from '../../utils/should-forward-prop';
import { H3, H6, SectionHeading, SmallStyles } from '../type';

const StyledHeading = styled(H3)`
  padding-top: ${SPACE.X3};
`;

const StyledSubHeading = styled(SectionHeading)`
  padding-top: ${SPACE.X0};
  padding-bottom: ${SPACE.X3};
`;

const AncapIcon = styled.img`
  margin-right: ${SPACE.X0};

  width: 35px;
  height: 35px;
  @media (min-width: ${BREAKPOINTS.LG}px) {
    width: 50px;
    height: 50px;
  }
`;

const SafetyFeatureRow = styled.dl`
  ${SmallStyles}
  display: flex;
  justify-content: space-between;
  margin-bottom: ${SPACE.X0};
`;

const AncapTestCategory = styled(H6)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${SPACE.X1};
  font-weight: ${FONT_WEIGHT.BOLD};
`;

const AncapTestCategoryHeading = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${SPACE.X1};
`;

const Bold = styled.span`
  font-weight: ${FONT_WEIGHT.BOLD};
`;

const Divider = styled.div`
  height: 2px;
  background-color: ${COLORS.GREY_FIVE};
  margin-top: ${SPACE.X3};
`;

const FeatureTileGridWrapper = styled.div`
  @media (min-width: ${BREAKPOINTS.LG}px) {
    margin-left: ${SPACE.X2};
  }
`;

const FeatureTileGrid = styled(Grid, { shouldForwardProp })`
  justify-content: flex-start;
  @media (min-width: ${BREAKPOINTS.MD}px) {
    justify-content: flex-end;
  }
  @media (min-width: ${BREAKPOINTS.LG}px) {
    justify-content: flex-start;
  }
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call.
const StyledStarRating = styled(StarRating)`
  min-height: auto;
`;

const ChildCarSeatsImg = styled.img`
  width: 75px;
  height: 75px;
  min-width: 75px;
  min-height: 75px;

  @media (min-width: ${BREAKPOINTS.LG}px) {
    width: 110px;
    height: 110px;
    min-width: 110px;
    min-height: 110px;
  }
  margin-right: ${SPACE.X1};
`;

const ChildCarSeatsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${SPACE.X1};
`;

const ChildCarSeatsInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ChildCarSeatsLink = styled.a`
  color: ${COLORS.BRAND_BLUE_EIGHT};
  font-weight: ${FONT_WEIGHT.BOLD};
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
  cursor: pointer;
  user-select: none;
`;

export {
  Divider,
  ChildCarSeatsWrapper,
  ChildCarSeatsInnerWrapper,
  ChildCarSeatsImg,
  ChildCarSeatsLink,
  StyledSubHeading,
  StyledHeading,
  AncapIcon,
  AncapTestCategoryHeading,
  SafetyFeatureRow,
  AncapTestCategory,
  Bold,
  FeatureTileGrid,
  FeatureTileGridWrapper,
  StyledStarRating,
};
